/// <amd-module name="Wit/SprintsHub/SprintsView/Services/ITaskboardShortcutService" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { IHotKeyEventType, IHotKeyEventService } from "Wit/Common/HotKeyEventService/IHotKeyEventService";
import * as Resources from "Wit/SprintsHub/SprintsView/Resources";

export interface ITaskboardShortcutService extends IVssService {
    registerShortcuts: (
        toggleFilter: () => void
    ) => void;
    unregisterShortcuts: () => void;
}

class TaskboardShortcutService extends VssService implements ITaskboardShortcutService {
    private shortcutService: IVssKeyboardShortcutService;

    public _serviceStart(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
        this.shortcutService = this.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
    }

    public _serviceEnd() {}

    public registerShortcuts = (
        toggleFilter: () => void
    ) => {
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+shift+f"],
            description: Resources.ToggleFilter,
            action: () => {
                toggleFilter();

                const hotKeyEventService = this.pageContext.getService<IHotKeyEventService>("IHotKeyEventService");
                hotKeyEventService.fireEvent({ }, IHotKeyEventType.FilterToggled);
            }
        });

        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["z"],
            description: Resources.ToggleFullScreenMode,
            action: () => {
                const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                layoutManager.toggleFullScreenMode();
            }
        });

        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["c"],
            description: Resources.NewChild,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // add a new child
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["enter"],
            description: Resources.OpenItem,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // open item
            },
            allowPropagation: true
        });

        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+up"],
            description: Resources.MoveUp,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item up
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+down"],
            description: Resources.MoveDown,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item down
            }
        });

        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+left"],
            description: Resources.MoveLeft,
            // globalCombos: ["mod+left"],
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item left
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+right"],
            description: Resources.MoveRight,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item right
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+shift+up"],
            description: Resources.MoveToRowAbove,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item to row above
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["mod+shift+down"],
            description: Resources.MoveToRowBelow,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // Move item to row below
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["shift+pageup"],
            description: Resources.SelectRowAbove,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // select row above
            }
        });
        this.shortcutService.registerShortcut(Resources.TaskBoard, {
            combos: ["shift+pagedown"],
            description: Resources.SelectRowBelow,
            action: () => {
                // Added here for accessibility reasons. Implemented in TaskboardContentView.
                // select row below
            }
        });
    };

    public unregisterShortcuts = () => {
        this.shortcutService.removeShortcutGroup(Resources.TaskBoard);
    };
}

Services.add("ITaskboardShortcutService", { serviceFactory: TaskboardShortcutService });
